<!--その他メニューコンポーネント-->
<template>
	<div class='OtherMenu'>
		<!--レイヤーメニュー表示-->
		<div class="position-absolute bg-primary text-white w-25" style="position: absolute; bottom: 30px; right: 0px; padding: 1px;">
			<accordion class="list-group-item-info text-black" title="地図の中心で">
				<ul class="list-group text-black">
					<li class="li-padding list-group-item-info text-left">
						<div class="pull-left text-black text-sm">リンク</div>
					</li>
					<li class="li-padding list-group-item-info text-left">
						<div class="pull-left" @click="manualPath">
							<span class="menu_link text-indent p-1 block text-sm flex justify-between bg-blue-dark hover:bg-blue-darker">地図の使い方</span>
						</div>
					</li>
					<li class="li-padding list-group-item-info text-left">
						<div class="pull-left" @click="mapMenuPath">
							<span class="menu_link text-indent p-1 block text-sm flex justify-between bg-blue-dark hover:bg-blue-darker">防災マップメニュー</span>
						</div>
					</li>
					<li class="li-padding list-group-item-info text-left">
						<div class="pull-left" @click="simMenuPath">
							<span class="menu_link text-indent p-1 block text-sm flex justify-between bg-blue-dark hover:bg-blue-darker">建物倒壊シミュレータメニュー</span>
						</div>
					</li>
				</ul>
			</accordion>
		</div>
	</div>
</template>

<script>
// アコーディオンメニュー
var accordion = {
	props: [
		'title'
	],
	data() {
		return {
			active: true,
		}
	},
	template: `
		<div class="">
			<div class="tab__header"></div>
			<div class="tab__content" v-show="active"><slot /></div>
		</div>
	`
}
export default {
	name: 'OtherMenu',
	components: {
		accordion
	},
	data () {
		return {
			message: "test!!"
		}
	},
	methods: {
		//ボタンをクリックするとこのメソッドが起動する
		click: function(){
				this.$emit('child-event', this.message);//親へイベント発火を伝える
		},
		manualPath:function(){
			var href = this.portalUrl + "pdf/mapManual.pdf";
			window.open(href, "_self");
		},
		mapMenuPath:function(){
			var href = this.portalUrl + "?page_id=130";
			window.open(href, "_self");
		},
		simMenuPath:function(){
			var href = this.portalUrl + "?page_id=17";
			window.open(href, "_blank");
		}
	}

}
</script>



<style>
@import "../../css/Menu.css";
</style>
